module.exports = __webpack_public_path__ + "static/about-img2-b5504d0e66a0b9308686a8730025d688.png";